// extracted by mini-css-extract-plugin
module.exports = {"Form":"Form_Form__1i9F8","registerGoogleForm":"Form_registerGoogleForm__bMycg"};